var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-store-locator-filters" }, [
    _c(
      "div",
      { staticClass: "rb-store-locator-filters__store-types grid grid--gap-1" },
      _vm._l(_vm.filters, function (filter) {
        return _c(
          "div",
          {
            key: filter.id,
            staticClass: "rb-store-locator-filters__store-type col-6 col-lg-4",
            class: {
              "rb-store-locator-filters__store-type--active":
                _vm.isFilterToggled(filter.id),
            },
          },
          [
            _c("input", {
              staticClass: "store-type__input",
              attrs: {
                id: "filter-" + filter.id,
                type: "checkbox",
                disabled: _vm.filtersAreDisabled,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleFilter(filter.id)
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleFilter(filter.id)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "store-type__label",
                class: {
                  "store-type__label--disabled rb-disabledrow":
                    _vm.filtersAreDisabled,
                },
                attrs: { for: "filter-" + filter.id },
              },
              [
                _c("span", {
                  staticClass: "common__icon",
                  class: _vm.getFilterIcon(filter.id),
                }),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.translateFilterLabel(filter.id)) +
                      "\n        "
                  ),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rb-store-locator-filters__checkboxes" },
      _vm._l(_vm.checkboxes, function (checkbox) {
        return _c(
          "div",
          {
            key: checkbox.id,
            staticClass: "rb-store-locator-filters__checkbox",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.toggleCheckbox(checkbox.id)
              },
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleCheckbox(checkbox.id)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.toggleCheckbox(checkbox.id)
                },
              ],
            },
          },
          [
            _c("rb-checkbox", {
              attrs: {
                id: checkbox.id,
                disabled: _vm.filtersAreDisabled,
                name: checkbox.id,
                title: _vm.translateFilterLabel(checkbox.id),
                type: "checkbox",
                validation: _vm.$v[checkbox.id],
                initialvalue: _vm.getInitialValue(checkbox.id),
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }